import styled from "styled-components";

export default styled.div`
  .chat-box-cont {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    &--inverted {
      justify-content: flex-end;
    }

    .chat-box {
      position: relative;
      min-height: 33px;

      border-radius: 12px;
      width: fit-content;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      max-width: 80%;

      .background {
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.12;
        background-color: blue;
        border-radius: 12px;

        &--inverted {
          .vergulilla {
            right: 13px;
            bottom: 14px;
            transform: rotateY(180deg) translate(-50%, 50%);
          }
        }

        &--normal {
          .vergulilla {
            left: 13px;
            bottom: 14px;
            transform: translate(-50%, 50%);
          }
        }

        .vergulilla {
          position: absolute;

          width: 35px;
          height: 35px;

          background-color: blue;
          z-index: 0;

          clip-path: path(
            "M11.3423 19.723C11.6797 11.0013 16.59 0 25.3182 0H27.4261C32.004 0 35.7288 3.68502 35.7779 8.26261V8.26261C35.8595 15.8628 22.5768 29.5181 15.2192 31.4247C4.00548 34.3305 -5.6282 37.5592 3.85719 31.832C9.2138 28.5978 11.1688 24.2082 11.3423 19.723Z"
          );
        }
      }
    }
  }
`;
